/**
 * bootstrap.prod.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Todd L Smith <tsmith@safetyweb.org>
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

// If we want to switch to AOT compilation. See the ng2 guide on modules
// import { BrowserModule } from "@angular/platform-browser";

import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { AppModule } from "./app.module";

if (location.search === "?noload")
{
    throw new Error("User flag (?noload) indicated bootstrap should abort.");
}

// Turns off advanced warnings about change detection and sanitization.
enableProdMode();

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/bootstrap.prod.ts